/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export const companyRouterSegment = 'company';

export const partnerRouterSegment = 'partner';
export const publicRouterSegment = 'public';
export const myCompanyRouterSegment = 'my-company';
export const signupRouterSegment = 'signup';
export const emailUnsubscribeRouterSegment = 'email-unsubscribe';

export const contactRouterSegment = 'contact';
export const contactListRouterSegment = 'list';
export const contactNewRouterSegment = 'new';
export const contactEditRouterSegment = 'edit';

export const addressRouterSegment = 'address';
export const addressListRouterSegment = 'list';
export const addressNewRouterSegment = 'new';
export const bpCompanyAddressNewRouterSegment = 'bp-partner-address';
export const addressEditRouterSegment = 'edit';

export const bankAccountRouterSegment = 'bank-account';
export const bankAccountListRouterSegment = 'list';
export const bankAccountAuditListRouterSegment = 'audit';

export const signupStepSegment = 'step';
export const signupAccountTypeStepSegment = 'account-type';
export const signupCompanyInfoStepSegment = 'company-info';
export const signupAddressStepSegment = 'first-address';
export const signupSubscriptionStepSegment = 'subscription';
export const signupPaymentInfoStepSegment = 'payment-info';
export const signupPaymentInfoStepSubscriptionTypeSegment = 'subscription-type'
export const signupPaymentMethodPendingSegment = 'payment-method-pending';
export const signupContactStepSegment = 'first-contact';

export const changePaymentMethodRouterSegment = 'change-payment-method';
export const paymentMethodPendingRouterSegment = 'payment-method-pending';

export const profileRouterSegment = 'profile';

export const companyUserRouterSegment = "company-user";
export const companyUserListRouterSegment = "list";

export const authenticateAnafRouterSegment = 'authenticate-anaf';
export const companyDashboardRouterSegment = 'dashboard';
export const termsAndConditionsRouterSegment = 'terms-and-conditions';
export const companyDetailsValidationRouterSegment = 'company-details-validation';

export const employeeRouterSegment = 'employee'
export const employeeNewRouterSegment = 'new'

export const companyPartnerViewRouterSegment = 'view'
export const companyPartnerPrivateRouterSegment = 'private'
